import jsFileDownload from 'js-file-download'
import { CALCULATION_ACTION, COUNTRY } from './constants'
import { uploadAction } from './actions'

import _isString from 'lodash/isString'
import _isNumber from 'lodash/isNumber'
import _isBoolean from 'lodash/isBoolean'
import _isNull from 'lodash/isNull'
import _isArray from 'lodash/isArray'
import _isPlainObject from 'lodash/isPlainObject'

export const RenderIf = (isTrue, children) => (isTrue ? children : null)
export const RenderAorB = (isTrue, childA, childB) => (isTrue ? childA : childB)

export const getPimBaseUrl = (value) => {
  switch (value) {
    case 'app.strongtie.com':
      return 'https://www.strongtie.com'
    case 'app-staging.strongtie.com':
      return 'https://www.strongtie.com'
    case 'dvrapiqas01':
      return 'https://www.strongtie.com' // 'https://qa2.sstpim.com'
    case 'dvrjutldev':
    case 'app-dev.mystrongtie.com':
      return 'https://www.strongtie.com' // 'https://qa2.sstpim.com'
    default:
      return 'https://www.strongtie.com'
  }
}

export const concatClasses = (...args) => {
  return args.reduce((acc, className) => (className ? `${className} ${acc}` : acc), '')
}

export const toDegree = (radian) => Number(((radian * 180) / Math.PI).toFixed(1))

export const calcPitch = (rise, run = 12) => Math.atan(rise / run)

export const toRadian = (degree) => (degree * Math.PI) / 180

export const calcRise = (radian, run = 12) => Number(Math.tan(radian) * run).toFixed(3)

// returns a value corresponding to the type of input (Note: Only works with DOMEventTarget)
export const formatEventValue = (eventTarget) => {
  const { value, checked, type } = eventTarget
  const updatedValue = {
    checkbox: checked,
    text: value,
    range: Number(value),
  }

  return updatedValue[type] ?? value
}

export const modifyStateAction = (state, action) => {
  const { name, value } = action.payload

  state[name] = value
}

export const updateStateAction = (state, action) => {
  return { ...state, ...action.payload }
}

export const isEmpty = (value) => value.length === 0
export const isUndefined = (value) => value === undefined
export const isNull = (value) => value === null
export const inBetween = (value, min, max) => min <= value && value <= max

export const hashCode = (str) => {
  let hash = 0,
    i,
    chr

  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0
  }

  return hash
}

export const doDownload = (state, fileName) => {
  const source = JSON.stringify(state, null, 0)
  const hash = hashCode(source)
  // console.log('download myHash=', myHash)
  // console.log('download myStr=', myStr)

  const data = Object.assign({}, { hash, source })

  jsFileDownload(JSON.stringify(data, null, 2), fileName + '.json')
}

export const isCalculationAction = (type) => {
  return type.endsWith(CALCULATION_ACTION.MODIFY) || type.endsWith(CALCULATION_ACTION.UPDATE)
}

export const isUploadAction = (type) => {
  return type === uploadAction.type
}

export const getRequestShortenUrl = () => {
  if (window.location.hostname === 'app.strongtie.com') return '/Archer/api/shorten-urls'

  return '/webapps/Archer/api/shorten-urls'
}

export const isFunction = (obj) => obj !== null && typeof obj === 'function'

export const stringsToDropdownOpt = (dataset) =>
  dataset.map((item) => ({ text: item, value: item }))

export const stringifyContentWithHash = (source) => {
  const stringifyObj = JSON.stringify(source, null, 0)
  const hash = hashCode(stringifyObj)

  return JSON.stringify({ hash, source }, null, 2)
}

export const toJSONFile = (stringifedContent, fileName) => {
  const blob = new Blob([stringifedContent], { type: 'application/json' })
  const file = new File([blob], `${fileName}.json`)
  return file
}

export const deepCopy = (obj) => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime())
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item)
      return arr
    }, [])
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj, key) => {
      newObj[key] = deepCopy(obj[key])
      return newObj
    }, {})
  }
}

export const isDecimal = (value) => {
  const regExp = new RegExp(/^[-+]?([0-9]+)?(\.[0-9]{1,})?$/)

  return regExp.test(value)
}

export const isInteger = (value) => {
  return Number.isInteger(value)
}

export const numberFormatted = (value) => {
  if (typeof value === 'string') {
    return isEmpty(value) ? value : isDecimal(value) ? parseFloat(value) : value
  } else if (
    typeof value !== 'object' ||
    typeof value === 'boolean' ||
    value === null ||
    value === undefined ||
    value instanceof Array ||
    value instanceof Date
  ) {
    return value
  } else if (value instanceof Object) {
    return Object.keys(value).reduce((output, key) => {
      output[key] = numberFormatted(value[key])

      return output
    }, {})
  } else return value
}

export const saveSettingState = (appConfig, initialSetting) => {
  const itemName = 'sst_bp_' + appConfig.appCode + '_settings'
  const settingsJson = localStorage.getItem(itemName)
  let savedSetting = JSON.parse(settingsJson)
  if (savedSetting) {
    delete savedSetting.theme
  }

  const newSavedSetting = Object.assign(
    {},
    { orientation: initialSetting.orientation, fontSize: initialSetting.fontSize },
    savedSetting,
  )
  localStorage.setItem(itemName, JSON.stringify(newSavedSetting))
}

export const isOneDropdownOption = (options) => options.length <= 1
export const toFractionDigits = (value, digit = 3) => {
  const maxFractionDigits = new RegExp(`^\\d+(\\.\\d{1,${digit - 1}})?$`)
  return maxFractionDigits.test(String(value)) ? value : Number(value).toFixed(digit)
}

export const toCapitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const setAppFontSize = (fontSize) => {
  document.documentElement.classList.remove(
    '-densityCompact',
    '-densityStandard',
    '-densityExpanded',
    '-densityDefault',
  )
  document.documentElement.classList.add(fontSize)
}

export const toSingleDepthObject = (o, prefix = '', result = {}, keepNull = true) => {
  if (_isString(o) || _isNumber(o) || _isBoolean(o) || (keepNull && _isNull(o)) || _isArray(o)) {
    result[prefix] = o
    return result
  }

  if (_isPlainObject(o)) {
    for (let i in o) {
      toSingleDepthObject(o[i], i, result, keepNull)
    }
    return result
  }

  return result
}

export const getDownloadContent = (inputState, outputState, appConfig) => {
  const { searchValue, showAllModels, sortBy } = outputState || {}
  const downloadContent = {
    appCode: appConfig?.appCode,
    appVersion: appConfig?.appVersion,
    calculation: {
      input: { ...inputState, searchValue, showAllModels, sortBy },
    },
  }
  return downloadContent
}

export const isCountryUSA = (country) => country === COUNTRY.USA